import mutations from './patientVaccination.mutations'
import actions from './patientVaccination.actions'
import getters from './patientVaccination.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}